import { render } from "./HowToPurchasePage.vue?vue&type=template&id=4992543c&scoped=true"
import script from "./HowToPurchasePage.vue?vue&type=script&lang=js"
export * from "./HowToPurchasePage.vue?vue&type=script&lang=js"

import "./HowToPurchasePage.vue?vue&type=style&index=0&id=4992543c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4992543c"]])

export default __exports__